const SkorGameIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM5.25 7.5C5.25 7.08579 5.58579 6.75 6 6.75H6.75V6C6.75 5.58579 7.08579 5.25 7.5 5.25C7.91421 5.25 8.25 5.58579 8.25 6V6.75H9V6C9 5.58579 9.33579 5.25 9.75 5.25C10.1642 5.25 10.5 5.58579 10.5 6V6.75H11.25V6C11.25 5.58579 11.5858 5.25 12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V6.75V7.5V8.25H12H11.25H10.5V9H11.25H12H12.75V9.75V10.5V11.25C12.75 11.6642 12.4142 12 12 12C11.5858 12 11.25 11.6642 11.25 11.25V10.5H10.5V11.25C10.5 11.6642 10.1642 12 9.75 12C9.33579 12 9 11.6642 9 11.25V10.5H8.25V11.25C8.25 11.6642 7.91421 12 7.5 12C7.08579 12 6.75 11.6642 6.75 11.25V10.5H6H5.25V9.75V9V8.25V7.5ZM6.75 9H8.25V8.25H6.75V9ZM6.75 7.5H8.25V6.75H6.75V7.5ZM9 7.5H10.5V6.75H9V7.5ZM10.5 9H9V8.25H10.5V9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SkorGameIcon;
